import {
  DocumentCountersDocument,
  DocumentCountersQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type DocumentCountType = 'companyInternalDocuments' | 'companyPublicDocuments' | 'employeeDocuments'

const useGetDocumentCounters = (variables: DocumentCountersQueryVariables) => {
  const { data, loading } = useQuery(DocumentCountersDocument, { variables })

  const getCounter = (spaceIdentifier: DocumentCountType): number =>
    data?.documents[spaceIdentifier]?.totalCount || 0

  const employeeCounter = getCounter('employeeDocuments')
  const companyInternalCounter = getCounter('companyInternalDocuments')
  const companyPublicCounter = getCounter('companyPublicDocuments')

  return {
    employeeCounter,
    companyInternalCounter,
    companyPublicCounter,
    loading,
  }
}

export default useGetDocumentCounters
